import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import { motion } from 'framer-motion';

// UI
import { Typography } from '@components/typography';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
export const RewardsInfo: React.FC = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-50px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      x: 30
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hidden: t1,
      visible: {
        opacity: 1,
        x: 0,
        transition: {
          duration: 0.5
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-2"><Typography variant="title5" component="p" className="font-medium">Your Friend Gets</Typography></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.div className="bg-primary-main text-white rounded-2xl p-8 relative overflow-hidden" variants={t2}><div className="relative z-10">{t3}<p className="text-secondary-main font-medium text-4xl md:text-5xl font-bold mb-4">$50<span className="text-2xl font-medium text-secondary-main ml-2">Cash Back</span></p><Typography variant="body2" component="p" className="text-white/85 leading-relaxed">They'll receive $50 cash back on their first stay. The perfect welcome gift.</Typography></div></motion.div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      x: 30
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      hidden: t5,
      visible: {
        opacity: 1,
        x: 0,
        transition: {
          duration: 0.5
        }
      }
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mb-2"><Typography variant="title5" component="p" className="font-medium">You Get</Typography></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="py-8"><div className="body-container max-w-5xl mx-auto"><motion.div initial="hidden" whileInView="visible" viewport={t0} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-2 gap-6">{t4}<motion.div className="bg-primary-main text-white rounded-2xl p-8 relative overflow-hidden" variants={t6}><div className="relative z-10">{t7}<p className="text-secondary-main font-medium text-4xl md:text-5xl font-bold mb-4">$50<span className="text-2xl font-medium text-secondary-main ml-2">Cash Back</span></p><Typography variant="body2" component="p" className="text-white/85 leading-relaxed">Earn $50 cash back for each friend who creates a Savvy account, use it on your next stay. Refer up to 5 friends and earn up to $250 cash back!</Typography></div></motion.div></motion.div></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};